export default __webpack_public_path__ + "7761b3fc54f9a5e7b02ae5fdc9afe4a0.jpg";